module.exports = __webpack_public_path__ + "img/modal-member.96ee8b79.svg";